export const SetObjectData = (data: any) => {
    localStorage.setItem('d', data);
}

export const GetObjectData = () => {
    return localStorage.getItem('d');
}